export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $uibModal,
        Account,
        Alert,
        ApplicationsResource,
        PasswordAuthenticationPoliciesService,
        ConfirmModal) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
        this.ApplicationsResource = ApplicationsResource;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        this.companyId = this.$state.params.companyId;
        const updateOrder = (array,search) =>{
            let i = array.findIndex(o => o.passwordPolicyName === search);
            if (i === 0) return;
            else return array.unshift(array.splice( i, 1 )[0]);
        }

        updateOrder(this.companyPasswordPolicies,'Default Policy')
    }

    editViewPolicy(policyId){
        this.$uibModal
            .open({
                component: 'passwordAuthenticationPoliciesViewEdit',
                resolve: {policy: ()=>this.PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(this.companyId,policyId)},
            }).result
        .then()
        .finally(() => (this.isAdding = false));
    }

    assignApp(policy){
        this.$uibModal
            .open({
                component: 'passwordAuthenticationPolicyAssignApplication',
                resolve: {
                    policy: policy,
                    policyDetails: ()=>this.PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(this.companyId,policy.passwordPolicyId),
                    defaultPolicy: ()=>this.companyPasswordPolicies.filter(policy=>policy.passwordPolicyName==='Default Policy')[0]
                },
            }).result
            .then();
    }

    deletePolicyModal(policyId){
        this.isRemoving=policyId;
        this.ConfirmModal({
            messageKey:'Do you want to delete this policy?',
            titleKey:'Delete Policy',
            confirmButtonTextKey:'Yes',
        })
            .then(() => this.PasswordAuthenticationPoliciesService.deletePasswordPolicy(this.companyId,policyId))
            .then(() => this.$state.reload('company.policies'))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.removed'))
            .finally(() => (this.isRemoving = null));
    }

    createnewPolicy(){
        this.isAdding = true;
        this.PasswordAuthenticationPoliciesService.createNewPasswordPolicy(this.companyId)
           // .then(() => this.$state.reload('company.policies'))
            .then((data)=>this.$state.go('company.policies.password-authentication-policy.edit-policy',{policyId: data.id}))
            .then(() => this.Alert('success', 'company.policies.authentication-access-policies.added'))
            .finally(() => (this.isAdding = false));
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/password-authentication-policy.controller.js